import { render, staticRenderFns } from "./ExamCard.vue?vue&type=template&id=005d5cbc&scoped=true&"
import script from "./ExamCard.vue?vue&type=script&lang=js&"
export * from "./ExamCard.vue?vue&type=script&lang=js&"
import style0 from "./ExamCard.vue?vue&type=style&index=0&id=005d5cbc&scoped=true&lang=css&"
import style1 from "./ExamCard.vue?vue&type=style&index=1&lang=css&"
import style2 from "@/assets/hometeacher/css/main.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "005d5cbc",
  null
  
)

export default component.exports